<section style="margin-top: 32px;">
  <h2 *ngIf="title">{{title}}</h2>
  <div class="field-container" style="margin-top: 32px;">
    <mat-form-field appearance="outline" style="width: 100%; margin: 20px 0 20px;">
      <mat-label>Indirizzo completo</mat-label>

      <input #placesField matInput [formControl]="placesCtrl" [placeholder]="'Indirizzo'">
      <mat-error *ngIf="placesCtrl.hasError('required')">Campo obbligatorio</mat-error>
      <mat-error *ngIf="placesCtrl.hasError('missingAddressField') && smartFormComponent?.form?.invalid">
        <span>L'indirizzo inserito risulta incompleto, riformulare la ricerca per includere i seguenti campi: </span>

        <span *ngFor="let e of placesCtrl.getError('missingAddressField'); index as i">{{(e |
          addressErrors) + (i < placesCtrl.getError('missingAddressField').length - 1 ? ', ' : '.' )}}</span>

      </mat-error>
    </mat-form-field>
  </div>


  <smart-form [fields]="fields"></smart-form>
  <!-- Replace Powered By Google image src with self hosted image. https://developers.google.com/maps/documentation/places/web-service/policies#other_attribution_requirements -->
  <img class="powered-by-google"
    src="https://storage.googleapis.com/geo-devrel-public-buckets/powered_by_google_on_white.png"
    alt="Powered by Google" />
</section>
